import { createSelector } from 'reselect'
import getCheckoutTravellerSchema from 'checkout/selectors/getCheckoutTravellerSchema'
import { buildTravellerInfo } from 'checkout/lib/utils/experiences/order'

export const getFormattedTravellers = createSelector(
  (state: App.State) => state.checkout.form.travellerForms,
  (state: App.State) => getCheckoutTravellerSchema(state),
  (travellerForms, schemaData) => {
    if (schemaData && travellerForms.length > 0) {
      return buildTravellerInfo(schemaData.accommodationFlightSchema, travellerForms)
    }
  },
)
